import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Avatar, Box, Link, Typography } from '@mui/material';

const Comment = ({ className, comment, ...rest }) => {
  return (
    <Box
      className={className}
      sx={{ display: 'flex', mb: 2 }}
      {...rest}
    >
      <Avatar
        alt="Person"
        component={RouterLink}
        src={comment.user?.avatarUrl ?? ''}
        to="#"
      />
      <Box
        flexGrow={1}
        p={2}
        ml={2}
        bgcolor="background.dark"
        sx={(theme) => ({ borderRadius: `${theme.shape.borderRadius}px` })}
      >
        <Box display="flex" alignItems="center" mb={1}>
          <Link
            color="textPrimary"
            component={RouterLink}
            to={comment.user?._id}
            variant="h6"
          >
            {comment.user?.name ?? ''}
          </Link>
          <Box flexGrow={1} />
          <Typography color="textSecondary" variant="caption">
            {moment(comment.createdAt).fromNow()}
          </Typography>
        </Box>
        <Typography variant="body1" color="textPrimary">
          {comment.body}
        </Typography>
      </Box>
    </Box>
  );
};

Comment.propTypes = {
  className: PropTypes.string,
  comment: PropTypes.object.isRequired,
};

export default Comment;
